import React, { HTMLAttributes, ReactNode } from 'react';
import { clsx } from 'clsx';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  variant?: 'default' | 'outlined' | 'elevated';
}

const Card: React.FC<CardProps> = ({
  children,
  hover = false,
  padding = 'md',
  variant = 'default',
  className,
  ...props
}) => {
  const baseClasses = 'card rounded-2xl overflow-hidden';
  
  const variantClasses = {
    default: 'bg-white dark:bg-gray-800 shadow-soft border border-gray-100 dark:border-gray-700/50',
    outlined: 'bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600',
    elevated: 'bg-white dark:bg-gray-800 shadow-lg border border-gray-100 dark:border-gray-700/50',
  };
  
  // Mobile-first padding - smaller on mobile, larger on desktop
  const paddingClasses = {
    none: '',
    sm: 'p-3 sm:p-4',
    md: 'p-4 sm:p-6',
    lg: 'p-5 sm:p-8',
  };
  
  const hoverClasses = hover ? 'card-hover' : '';
  
  const classes = clsx(
    baseClasses,
    variantClasses[variant],
    paddingClasses[padding],
    hoverClasses,
    className
  );

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;
